/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global FormValidation, restCollection, autocompleete, schema, lng, Element, RestEdit, snackbar, RestEditBasic, CONTENT, CONTENT_TARGET, Promise */

function RestEditCollection(rest, collectionKey) {
  if (!this instanceof RestEditCollection)
    return new RestEditCollection(rest, collectionKey);

  var that = this;

  // -- attributes --
  this.node = document.createElement("div");
  this.node.classList.add("mdl-tabs__panel");

  this._collectionSchema = rest.schemaData[collectionKey];
  this.node.id = that._collectionSchema.label; // set an id for tabs

  /**
   * @type RestSubject
   */
  this._subject = null;
  this._subjectCollection = null;
  this._tbody = null;

  this.onclose = function () {
    console.warn("onclose() Overwrite this!");
  };
  this.onchange = function () {
    console.warn("onchange() Overwrite this!");
  };

  // -- functions --
  this.loadSubject = loadSubject;
  this.destroy = destroy;

  // -- init --
  (function () {
    that.node.classList.add("rest-edit-collection");
    that.node.classList.add("mdl-card");
    // <h4>${that._collectionSchema.label}</h4>
    var html = `
            <table class="mdl-data-table mdl-js-data-table">
                <thead>
                    <tr></tr>
                </thead>
                <tbody>
                    <tr class="add"></tr>
                </tbody>
            </table>
            `;
    if (collectionKey === "appLicence") {
      html = `<div class="appLicence"></div>` + html;
    }
    that.node.insertAdjacentHTML("beforeend", html);
    that._tbody = that.node.querySelector("tbody");

    var theadtr = that.node.querySelector("thead tr");
    var trAdd = that._tbody.querySelector("tr.add");
    var tdAdd = document.createElement("td");
    tdAdd.colSpan = that._collectionSchema.cols.length;

    trAdd.appendChild(tdAdd);

    //create header
    var cols = that._collectionSchema.cols;
    for (var i = 0, len = cols.length; i < len; i++) {
      var col = cols[i];
      var th = document.createElement("th");
      th.classList.add("rest-edit-header");

      th.textContent = col.label;
      theadtr.appendChild(th);

      if (col.sorting) {
        th.insertAdjacentHTML(
          "beforeend",
          '<i class="material-icons sorting-icon default">code</i>'
        );
        th.classList.add("sorting");
        th.id = col.sortingKey;

        th.addEventListener("click", (event) => {
          let allIcons = theadtr.querySelectorAll(
            ".material-icons.sorting-icon"
          );
          allIcons = Array.from(allIcons);
          allIcons.map((icon) => {
            icon.parentNode.removeChild(icon);
          });

          let direction;
          if (event.target.classList.contains("ASC")) {
            event.target.classList.remove("ASC");
            event.target.classList.add("DESC");
            direction = "DESC";
            event.target.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            event.target.classList.remove("DESC");
            event.target.classList.add("ASC");
            direction = "ASC";
            event.target.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          //remove old
          var trs = that._tbody.children;
          var addTr;
          for (var i = 0, len = trs.length; i < len; i++) {
            let tr = trs[i];
            if (tr.classList.contains("add")) {
              addTr = tr;
              continue;
            }
            that._tbody.removeChild(tr);
            i--;
            len--;
          }

          let sortingKeyTemp = event.target.id;
          sortingKeyTemp = sortingKeyTemp.split(".");

          that._subjectCollection.data.sort((a, b) => {
            let objectA, objectB;

            if (sortingKeyTemp.length > 1) {
              objectA = a[sortingKeyTemp[0]][sortingKeyTemp[1]];
              objectB = b[sortingKeyTemp[0]][sortingKeyTemp[1]];
            } else {
              objectA = a[sortingKeyTemp[0]];
              objectB = b[sortingKeyTemp[0]];
            }

            if (direction === "ASC") {
              return objectA > objectB ? 1 : -1;
            } else {
              return objectB > objectA ? 1 : -1;
            }
          });

          drawNew(that._subjectCollection.data);
        });
      }
    }

    //create add section
    switch (that._collectionSchema.addMode) {
      case schema.COLLECTION_ADD_MODE.ADD:
        collectionModeAdd();
        break;
      case schema.COLLECTION_ADD_MODE.CREATE:
        collectionModeCreate();
        break;
      case schema.COLLECTION_ADD_MODE.ADD_CREATE:
        collectionModeAdd();
        collectionModeCreate();
        break;
      case schema.COLLECTION_ADD_MODE.THROUGH_ADD:
        collectionModeThroughAdd();
        break;
      case schema.COLLECTION_ADD_MODE.CREATE_IMPORT:
        collectionModeCreateAndImport();
        break;
      default:
        trAdd.parentNode.removeChild(trAdd);
    }

    function collectionModeAdd() {
      tdAdd.insertAdjacentHTML(
        "beforeend",
        `
                <div>
                    <input class="add" type="text" placeholder="${lng.get(
                      collectionKey
                    )} hinzufügen">
                    <button class="add mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--primary" disabled>Hinzufügen</button>
                </div>`
      );

      //initialize collection add input
      const addInput = that._tbody.querySelector("tr.add input.add");
      const addButton = that._tbody.querySelector("tr.add button.add");
      FormValidation.delayedTextInput(addInput, function (value) {
        if (!that._subjectCollection) return;

        var rowIDs = [];
        for (let i = 0, len = that._subjectCollection.length; i < len; i++) {
          if (that._subjectCollection[i].data)
            rowIDs.push(that._subjectCollection[i].data.id);
          else rowIDs.push(that._subjectCollection[i].id);
        }

        const schemakey = that._collectionSchema.via || collectionKey;
        const collectionToSearch = restCollection[schemakey];

        if (!collectionToSearch)
          throw new Error(`restCollection ${schemakey} not found`);

        collectionToSearch
          .textSearch({
            search: value,
          })
          .then((found) => {
            //filter already assigned items
            //the api does not provide a where parameter yet
            found = found.filter((item) => !rowIDs.includes(item.id)); //TODO FIXME

            //use the getString() function of the schema to parse a name for autocompleete.
            found = found.map((item) => {
              if (item.name) return item;

              //use an simulated row object with the key from schema, not the model (.via) key
              var virtualRow = {};
              virtualRow[collectionKey] = [item]; //the getString function of collections expects an array
              if (that._collectionSchema.getString)
                item.name = that._collectionSchema.getString(virtualRow);

              return item;
            });

            autocompleete.use(addInput, found, function (val) {
              addInput.value = val.name; //name was parsed above
              addInput.data = val;
              addButton.disabled = false;
            });
          });
      });
      addInput.addEventListener("keyup", function () {
        addButton.disabled = true;
      });
      addButton.addEventListener("click", function () {
        if (this.disabled || !that._subject) return;

        that._subjectCollection.add(addInput.data.id).then((mainObj) => {
          addInput.value = null;
          addInput.data = null;
          addButton.disabled = true;

          that.onchange();
        });
      });
    }

    function collectionModeCreate() {
      var collectionSchemaKey = that._collectionSchema.via || collectionKey;

      //check accessCreate permission
      var accessCreate = schema[collectionKey].accessCreate;
      if (typeof accessCreate === "function" && !accessCreate()) return;

      tdAdd.insertAdjacentHTML(
        "beforeend",
        `
                <div>
                    <button class="create mdl-button mdl-js-button mdl-button--raised mdl-button--colored">${lng.get(
                      collectionKey
                    )} Erstellen</button>
                </div>`
      );

      //initialize collection add input
      var createButton = that._tbody.querySelector("tr.add button.create");
      createButton.addEventListener("click", function (e) {
        collectionSchemaKey = camelCaseToSnakeCase(collectionSchemaKey);

        var dataForView = {
          id: "new",
        };
        var subObj = {};
        var subjectData = that._subject.data;
        for (var i in subjectData) {
          var d = subjectData[i];
          switch (typeof d) {
            case "object":
            case "function":
              continue;
            default:
              subObj[i] = d;
          }
        }
        dataForView[rest.schemaKey] = subObj;

        CONTENT_TARGET.changeContent(CONTENT[collectionSchemaKey], dataForView);
      });
    }

    //initialize collection create import and export for locationPartner
    function collectionModeCreateAndImport() {
      tdAdd.insertAdjacentHTML(
        "beforeend",
        `<table class="through mdl-data-table mdl-js-data-table"></table>`
      );

      var throughSchemaKey = that._collectionSchema.via || collectionKey;
      var throughSchema = schema[throughSchemaKey];
      var table = trAdd.querySelectorAll("table.through");

      table = table[table.length - 1]; //catch multiple and get the last one

      for (var key in throughSchema.schemaData) {
        var throughSchemaItem = throughSchema.schemaData[key];
        if (throughSchemaItem.type === "collection") continue;

        if (key === rest.schemaKey)
          //self reference will be set automaticly while collecting data
          continue;

        if (throughSchemaItem.access && !throughSchemaItem.access({})) continue;

        var tr = document.createElement("tr");
        table.appendChild(tr);
        var tdLabel = document.createElement("td");
        var label = document.createElement("label");
        label.textContent = lng.get(
          `${throughSchemaKey}_${snakeCaseToCamelCase(key)}`
        );
        tdLabel.appendChild(label);
        tr.appendChild(tdLabel);
        var tdInput = document.createElement("td");
        tr.appendChild(tdInput);
        RestEdit.genInput(throughSchemaItem, key, tdInput, table);
      }

      table.insertAdjacentHTML(
        "beforeend",
        `
                <tr><td colspan="2">
                        <input type="file" style="display: none" class="fileimport" id="fileimport">
                        <button class="import mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Importieren</button>
                    
                        <button class="export mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Exportieren</button>
                    
                    
                        <button class="create mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Hinzufügen</button>
                </td></tr>`
      );
      var saveButton = table.querySelector("button.create");
      var importButton = table.querySelector("button.import");
      var exportButton = table.querySelector("button.export");
      var fileimportinput = table.querySelector("input.fileimport");
      fileimportinput.addEventListener("change", importFile, false);

      function importFile() {
        var fileList = this.files;
        if (fileList.length > 0) {
          var file = fileList[0];
          if (file.name.substring(file.name.length - 4) === ".csv") {
            const reader = new FileReader();
            reader.onload = (function (theFile) {
              return function (e) {
                var data = window.atob(
                  e.target.result.split(";base64,")[1].toString()
                );
                var locations = data.split("\n");
                var savepromises = [];
                for (var i = 1, loc; (loc = locations[i]); i++) {
                  var locdata = loc.split(";");
                  if (!(locdata.length > 1)) locdata = loc.split(",");
                  if (locdata.length === 2 || locdata.length === 3) {
                    var newInstance =
                      restCollection[throughSchemaKey].createEmptyInstance();
                    newInstance.data[rest.schemaKey] = that._subject.data.id;
                    newInstance.data.locationname = locdata[0].replace(
                      /["']/g,
                      ""
                    );
                    newInstance.data.adress = locdata[1].replace(/["']/g, "");
                    if (locdata.length === 3)
                      newInstance.data.mas_number = locdata[2];

                    if (
                      newInstance.data.locationname &&
                      newInstance.data.locationname.length > 0
                    ) {
                      savepromises.push(newInstance.save());
                    }
                  }
                }
                Promise.all(savepromises)
                  .then(() => that._subject.reload())
                  .then(() => that.onchange());
              };
            })(file);

            // Read in the image file as a data URL.
            reader.readAsDataURL(file);
          } else {
            snackbar.show({
              message: "Der ausgewählte Dateityp ist nicht korrekt.",
            });
          }
        }
      }

      exportButton.addEventListener("click", function (e) {
        var collectionSchemaKey = that._collectionSchema.via || collectionKey;
        var collectionRest = restCollection[collectionSchemaKey];
        var rows = that._subjectCollection;
        var queryWhere = {
          id: rows.map((colItem) => colItem.id),
        };

        collectionRest
          .find({
            where: JSON.stringify(queryWhere),
            populate: "", //pop all
          })
          .then((data) => {
            let csvstring = [];
            csvstring.push("Standortbezeichnung;Adresse;Marketingnummer\n");
            for (let i = 0, lp; (lp = data[i]); i++) {
              csvstring.push(
                lp.location.name +
                  ";" +
                  lp.location.adress +
                  ";" +
                  lp.mas_number +
                  "\n"
              );
            }
            csvstring = csvstring.join("");
            csvstring = window.btoa(csvstring);
            csvstring = "data:text/csv;base64," + csvstring;
            const a = document.createElement("a");
            a.download = `Standorte_${new Date().toLocaleDateString()}.csv`;
            a.href = csvstring;
            a.style.display = "none";
            this.parentNode.insertBefore(a, this);
            a.click();
            a.parentNode.removeChild(a);
          });
      });
      importButton.addEventListener("click", function (e) {
        const fileImport = table.querySelector("input.fileimport");
        fileImport.click();
      });
      saveButton.addEventListener("click", function (e) {
        if (!that._subject.data.id) {
          snackbar.show({ message: "Speichern Sie zunächst die Stammdaten" });
          return;
        }

        saveButton.disabled = true;

        const newInstance =
          restCollection[throughSchemaKey].createEmptyInstance();
        newInstance.data[rest.schemaKey] = that._subject.data.id;
        RestEditBasic.collectData(newInstance, throughSchema.schemaData, table);
        newInstance
          .save()
          .then(() => that._subject.reload())
          .then(() => {
            that.onchange();
            saveButton.disabled = false;
          })
          .catch((e) => {
            saveButton.disabled = false;

            const msg =
              lng.get(`${rest.schemaKey}_${e.status}`) ||
              lng.get(e.status) ||
              lng.get("unknownError");
            snackbar.show({
              message: msg,
            });
          });
      });
    }

    function collectionModeThroughAdd() {
      tdAdd.insertAdjacentHTML(
        "beforeend",
        `<table class="through mdl-data-table mdl-js-data-table"></table>`
      );

      var throughSchemaKey = that._collectionSchema.via || collectionKey;
      var throughSchema = schema[throughSchemaKey];
      var table = trAdd.querySelectorAll("table.through");

      table = table[table.length - 1]; //catch multiple and get the last one

      for (var key in throughSchema.schemaData) {
        var throughSchemaItem = throughSchema.schemaData[key];
        if (throughSchemaItem.type === "collection") continue;

        if (key === rest.schemaKey)
          //self reference will be set automaticly while collecting data
          continue;

        if (throughSchemaItem.access && !throughSchemaItem.access({})) continue;

        var tr = document.createElement("tr");
        table.appendChild(tr);
        var tdLabel = document.createElement("td");
        var label = document.createElement("label");
        label.textContent = lng.get(
          `${throughSchemaKey}_${snakeCaseToCamelCase(key)}`
        );
        tdLabel.appendChild(label);
        tr.appendChild(tdLabel);

        var tdInput = document.createElement("td");
        tr.appendChild(tdInput);
        RestEdit.genInput(throughSchemaItem, key, tdInput, table);
      }

      table.insertAdjacentHTML(
        "beforeend",
        `
                <tr><td colspan="2">
                    <button class="create mdl-button mdl-js-button mdl-button--raised mdl-button--colored">Hinzufügen</button>
                </td></tr>`
      );
      var saveButton = table.querySelector("button.create");
      saveButton.addEventListener("click", function (e) {
        if (!that._subject.data.id) {
          snackbar.show({ message: "Speichern Sie zunächst die Stammdaten" });
          return;
        }

        saveButton.disabled = true;

        var newInstance =
          restCollection[throughSchemaKey].createEmptyInstance();
        newInstance.data[rest.schemaKey] = that._subject.data.id;
        RestEditBasic.collectData(newInstance, throughSchema.schemaData, table);
        newInstance
          .save()
          .then(() => that._subject.reload())
          .then(() => {
            that.onchange();
            saveButton.disabled = false;
          })
          .catch((e) => {
            saveButton.disabled = false;

            var msg =
              lng.get(`${rest.schemaKey}_${e.status}`) ||
              lng.get(e.status) ||
              lng.get("unknownError");

            snackbar.show({
              message: msg,
            });
          });
      });
    }
  })();

  /**
   * Draw content of a single collection from current dataset
   * @param {RestSubject} subject
   * @returns {undefined}
   */
  function loadSubject(subject) {
    that._subject = subject;
    that._subjectCollection = that._subject.data[collectionKey];

    const scrollContent = document.querySelector(".mdl-layout__content");
    const scrollPosition = scrollContent.scrollTop;

    //remove old
    var trs = that._tbody.children;
    var addTr;
    for (var i = 0, len = trs.length; i < len; i++) {
      let tr = trs[i];
      if (tr.classList.contains("add")) {
        addTr = tr;
        continue;
      }
      that._tbody.removeChild(tr);
      i--;
      len--;
    }
    var appLicence = that.node.querySelector("div .appLicence");
    if (appLicence) {
      if (that._subject.data.contract[0]) {
        appLicence.innerHTML =
          that._subject.data.appLicence.length +
          " von " +
          that._subject.data.contract[0].licence_contingent +
          " Lizenzen in Benutzung";
      } else {
        appLicence.innerHTML =
          "Es existiert kein Vertrag für den Dienstleister.";
      }
    }
    var rows = that._subjectCollection;
    if (!that._collectionSchema.populate) return drawNew(rows);

    var collectionSchemaKey = that._collectionSchema.via || collectionKey;
    var collectionRest = restCollection[collectionSchemaKey];
    var queryWhere = {
      id: rows.map((colItem) => colItem.id),
    };

    if (
      collectionRest &&
      (collectionRest.schemaKey == "appLicence" ||
        "employeePartner" ||
        "formPartner" ||
        "locationPartner")
    ) {
      if (queryWhere.id && queryWhere.id.length > 1) {
        queryWhere.id = queryWhere.id.slice(0, 1);
      }
    }

    collectionRest
      .find({
        where: JSON.stringify(queryWhere),
        populate: "", //pop all
      })
      .then((data) => {
        rows = data;
        that._subjectCollection.data = data;
        drawNew(rows, scrollPosition);
      });
  }

  function drawNew(rows, scrollPosition) {
    var firstAddTr = that._tbody.querySelector("tr.add");
    for (var i = 0, len = rows.length; i < len; i++) {
      let row = rows[i];
      var tr = document.createElement("tr");

      const cols = that._collectionSchema.cols;

      // if(typeof that._collectionSchema.class != 'undefined'){
      //     var tdClass = that._collectionSchema.class // class for tds
      // }
      for (var j = 0, len2 = cols.length; j < len2; j++) {
        const col = cols[j];
        const td = document.createElement("td");

        var div = document.createElement("div");
        td.appendChild(div);
        //use the function of each col to parse data
        const tdContent = col.function(that._subject, row);

        switch (typeof tdContent) {
          case "string":
            //'remove-icon' is the flag for creating an remove from collection button
            if (tdContent === "remove-icon") {
              var removeIconWrapper = document.createElement("i");
              removeIconWrapper.insertAdjacentHTML(
                "beforeend",
                schema.ICONS.REMOVE
              );
              var removeIcon = removeIconWrapper.children[0];
              removeIcon.addEventListener("click", removeHandler);
              div.appendChild(removeIcon);
              div.classList.add("remove");
            } else {
              var p = document.createElement("p");
              p.insertAdjacentHTML("beforeend", tdContent || "");
              div.appendChild(p);

              // --- add class to input
              if (col.class) {
                p.classList = col.class;
              }
              // --- add parent class
              if (col.wrapperClass) {
                p.parentNode.classList = col.wrapperClass;
              }
            }
            break;

          case "object":
            if (tdContent instanceof Element) {
              div.appendChild(tdContent);
              // --- add class to input
              if (col.class) {
                tdContent.classList = col.class;
              }
              // --- add parent class
              if (col.wrapperClass) {
                tdContent.parentNode.classList = col.wrapperClass;
              }
              //tdContent.onChange = tr.redraw; //do not confound with native onchange
              tdContent.onChange = () => loadSubject(that._subject);
            } else {
              console.error("tdContent is object, but not Element", tdContent);
            }
            break;
        }

        if (col.align) {
          td.classList.add("--" + col.align);
        }

        tr.appendChild(td);
      }
      tr.data = row;
      that._tbody.insertBefore(tr, firstAddTr);
    }

    if (scrollPosition > 0) {
      const scrollContent = document.querySelector(".mdl-layout__content");
      scrollContent.scrollTop = scrollPosition;
    }
  }

  function removeHandler() {
    //get tr for data
    var tr = this;
    var td;
    while (tr.tagName !== "TR" && tr !== document.body) {
      if (tr.tagName === "TD") td = tr;
      tr = tr.parentNode;
    }

    if (tr.tagName !== "TR") {
      console.error("tr not found");
      return;
    }

    if (td.classList.contains("animation"))
      //prozess already running
      return;

    td.classList.add("animation");

    that._subjectCollection.remove(tr.data.id).then((mainObj) => {
      td.classList.remove("animation");
      that.onchange();
    });
  }

  /**
   * Try to remove as many as possible pointers to make the work for the gc easer
   * and possibly remove deadlocks.
   * @returns {Promise}
   */
  function destroy() {
    return new Promise((resolve, reject) => {
      for (var i in that) that[i] = null;
      resolve();
    });
  }
}
